import React from "react";

const ProductDescription = () => {
  return (
    <div className="rv-product-details__descr">
      <h6 className="rv-product-details-bottom__title">Product Description</h6>
      <p>
        Make those striking eyes of yours pop with our improved Color Icon
        eyeshadow formula. We’ve combined super-saturated pigmentation and
        pearlescents into our go-to singles. The satiny texture feels as good as
        it looks–sans fading or creasing–with better blendability and major
        staying power. Reformulated matte shadows softly glide over skin Holds
        fast to the eyelids despite the rubs of everyday life Provides intense
        color payout with high-impact pigments Delivers an elegant silky texture
        and superior blendability Applies smoothly and evenly with
        silica-enriched formula
      </p>
    </div>
  );
};

export default ProductDescription;
